import { useEffect } from "react";

export default function FeaturesPage() {
	useEffect(() => {
		const user = window.localStorage.getItem("user");
		if (user) {
			const parsedUser = JSON.parse(user);

			window.location.href = `/organization/${parsedUser.superTenantId}/managers/`;
		}
	}, []);
	return null;
}
